import React, { useEffect, useRef, useState } from "react";
import Icon from "../../../stories/core-components/IconsSelector";
import * as S from "./AltSlick.styles";

const AltSlick = (props) => {
    const {
        autoplaySpeed = 3000,
        autoplay = false,
        slidesToShow = 1,
        slidesToScroll = 1,
        infinite = false,
    } = props;

    const [elementsScrolled, setElementsScrolled] = useState(0);
    const innerSliderRef = useRef(null);
    const [reachedEnd, setReachedEnd] = useState(false);

    // const arrowImg = "https://gos3.ibcdn.com/arrowBlue-1655894643.png";

    // const dotsElLst = props.children.map((_, idx) => (
    //     <div className={`altSlick__dot ${idx === activeIdx ? `altSlick__dot--actv` : ``}`} key={'klko' + _} />
    // ));

    const goToNext = () => {
        let newScrlVal =
            (100 / slidesToShow) * elementsScrolled +
            (100 / slidesToShow) * slidesToScroll +
            (infinite ? (100 / slidesToShow) * slidesToShow : 0);
        if (
            elementsScrolled + slidesToShow + slidesToScroll <=
            props.children.length
        )
            setElementsScrolled(
                (elementsScrolled) => elementsScrolled + slidesToScroll
            );
        else {
            const remainingSlides =
                props.children.length - (elementsScrolled + slidesToShow); // can use modulo operator here to find remainder
            newScrlVal =
                (100 / slidesToShow) * elementsScrolled +
                (100 / slidesToShow) * remainingSlides +
                (infinite ? (100 / slidesToShow) * slidesToShow : 0);
            setElementsScrolled(
                (elementsScrolled) => elementsScrolled + remainingSlides
            );
            if (infinite) setReachedEnd(true);
        }
        innerSliderRef.current.style.transform = `translate(${-1 * newScrlVal}%)`;
    };

    const goToPrev = () => {
        const sliderSize = props.children.length;
        let newScrlVal =
            (100 / slidesToShow) * elementsScrolled -
            (100 / slidesToShow) * slidesToScroll +
            (infinite ? (100 / slidesToShow) * slidesToShow : 0);
        if (elementsScrolled - slidesToScroll >= 0)
            setElementsScrolled(
                (elementsScrolled) => elementsScrolled - slidesToScroll
            );
        else {
            newScrlVal = (100 / slidesToShow) * elementsScrolled;
            setElementsScrolled(0);
        }
        innerSliderRef.current.style.transform = `translate(${-1 * newScrlVal}%)`;
    };

    const makeSlidsList = () => {
        const newSlidesList = [];
        const sliderSize = props.children.length;
        for (let i = 0; i < sliderSize; i++) {
            newSlidesList.push(
                <S.AltSlickInrSlidWrap style={{ width: `${100 / slidesToShow}%` }}>
                    {React.cloneElement(props.children[i], {
                        key: 100 * (i + 1),
                    })}
                </S.AltSlickInrSlidWrap>
            );
        }
        return newSlidesList;
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            innerSliderRef.current.style.transition = "ease 1000ms";
        }, 100);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (autoplay) {
            const interval = setTimeout(() => {
                goToNext();
            }, autoplaySpeed);
            return () => clearTimeout(interval);
        }
    }, [elementsScrolled, reachedEnd]);

    const crslElLst = makeSlidsList();

    return (
        <S.AltSlickContainer>
            <S.AltSlickSlideContainer>
                <S.AltSlickInrSlider ref={innerSliderRef}>
                    {crslElLst}
                </S.AltSlickInrSlider>
                {elementsScrolled > 0 ? <S.AltSlickLeftBtn onClick={goToPrev}>
                    <Icon
                        name="ArrowRight"
                        styleProps={{ fill: '#2276e3', width: '2rem', height: '2rem' }}
                    />
                </S.AltSlickLeftBtn> : <></>}
                <S.AltSlickRightBtn onClick={goToNext}>
                    <Icon
                        name="ArrowRight"
                        styleProps={{ fill: '#2276e3', width: '2rem', height: '2rem' }}
                    />
                </S.AltSlickRightBtn>
            </S.AltSlickSlideContainer>
        </S.AltSlickContainer>
    );
};

export default AltSlick;
